import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogOut, BarChart3, Plus, Home } from 'lucide-react';

const Navbar = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/dashboard" className="navbar-brand">
            <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Logo" className="navbar-logo" />
            <span>GP Forms</span>
          </Link>
          <ul className="navbar-nav">
            <li>
              <Link to="/dashboard" className="nav-link">
                <Home size={18} />
                Dashboard
              </Link>
            </li>
            <li>
              <Link to="/builder" className="nav-link">
                <Plus size={18} />
                Crear Encuesta
              </Link>
            </li>
            <li>
              <Link to="/analytics" className="nav-link">
                <BarChart3 size={18} />
                Analítica
              </Link>
            </li>
          </ul>
          <div className="navbar-user">
            <div className="navbar-user-circle">
              {user?.username?.charAt(0).toUpperCase() || 'A'}
            </div>
            <span className="nav-link" style={{ color: '#19B394', fontWeight: 600, fontSize: 16 }}>
              {user?.username}
            </span>
            <button onClick={handleLogout} className="navbar-logout-btn">
              <LogOut size={18} style={{ marginRight: '5px' }} />
              Salir
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 